import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router';
import { OutGoingTable } from '../componenets/outGoingTable';

interface FulfilledOrdersProps {}

export const FulfilledOrders: React.FC<FulfilledOrdersProps> = ({}) => {
  const history = useHistory();
  const [pages, setPages] = useState<number>(1);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const { t } = useTranslation();
  const location = useLocation<{ from: string }>();
  const pagesElements = [];
  for (let i = 0; i < pages; i++) {
    pagesElements.push(
      <li className="page-item">
        <a
          className="page-link"
          href="#"
          onClick={() => {
            setCurrentPage(i + 1);
          }}
        >
          {i + 1}
        </a>
      </li>
    );
  }
  return (
    <div className="container" style={{ marginTop: '1rem' }}>
      <div className="d-flex justify-content-between mb-3">
        <h2 className="mb-0" style={{ color: '#302363' }}>
          <i className="fas fa-boxes mx-1"></i>
          {t('orders:fulfilledOrders')}
        </h2>
        <button
          className="btn btn-dark mx-1"
          type="button"
          onClick={() => {
            if (location.state?.from === '/') history.goBack();
            else history.push('/');
          }}
        >
          <i className="fas fa-boxes mx-1"></i>
          {t('stock:backToOrders')}
        </button>
      </div>
      <div className="card">
        <div className="card-body">
          <div className="table-responsive">
            <OutGoingTable
              setPages={setPages}
              filters={{
                limit: 20,
                page: currentPage,
                filters: [{ status: 'DELIVERED' }],
              }}
            />
          </div>
        </div>
        <div className="card-footer d-flex justify-content-center">
          <nav>
            <ul className="pagination">
              <li className="page-item">
                <a
                  className="page-link"
                  href="#"
                  aria-label="Previous"
                  onClick={() => {
                    if (currentPage - 1 < 1) return;
                    setCurrentPage(currentPage - 1);
                  }}
                >
                  <span aria-hidden="true">«</span>
                </a>
              </li>
              {pagesElements}

              <li className="page-item">
                <a
                  className="page-link"
                  href="#"
                  aria-label="Next"
                  onClick={() => {
                    if (currentPage + 1 > pages) return;
                    setCurrentPage(currentPage + 1);
                  }}
                >
                  <span aria-hidden="true">»</span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  );
};
